import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const WabaTemplateGroupPermissionGate = (props: Omit<BasePermissionGateProps<"waba-template">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="waba-template"
		/>
	)
}

export default WabaTemplateGroupPermissionGate
